import { useState, useEffect } from "react";
import { Reports } from "@/pages/Reports";
import { Transaction, Category } from "@/types/database";
import { supabase } from "@/integrations/supabase/client";
import { MobileLayout } from "@/components/layout/MobileLayout";
import { useIsMobile } from "@/hooks/use-mobile";
import { ProtectedRoute } from "@/components/layout/ProtectedRoute";

export default function ReportsPage() {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const isMobile = useIsMobile();

  const handleTabChange = (tab: string) => {
    // Handle tab navigation if needed
  };

  const handleTransactionSuccess = () => {
    fetchTransactions();
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const { data, error } = await supabase
        .from("transacoes")
        .select(`
          *,
          categoria:categorias(*)
        `)
        .order("data", { ascending: false });
      
      if (error) throw error;
      
      const transactionsData = (data || []) as Transaction[];
      setTransactions(transactionsData);
      
      // Extrair categorias únicas das transações
      const uniqueCategories = Array.from(new Map(
        transactionsData
          .filter(t => t.categoria)
          .map(t => [t.categoria!.id, t.categoria!])
      ).values());
      
      setCategories(uniqueCategories);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const reportsContent = (
    <Reports 
      transactions={transactions}
      selectedDate={selectedDate}
      onDateChange={setSelectedDate}
      categories={categories}
    />
  );

  if (isMobile) {
    return (
      <ProtectedRoute>
        <MobileLayout
          currentTab="reports"
          onTabChange={handleTabChange}
          onTransactionSuccess={handleTransactionSuccess}
        >
          {reportsContent}
        </MobileLayout>
      </ProtectedRoute>
    );
  }

  return (
    <ProtectedRoute>
      {reportsContent}
    </ProtectedRoute>
  );
}